// Floating weed leaves JS
(function(){
  try{
    var count = 6;
    var container = document.body;
    for (var i=0;i<count;i++){
      var leaf = document.createElement('img');
      leaf.src = 'https://i.imgur.com/8YQ9Yg1.png'; // weed leaf icon
      leaf.className = 'leaf';
      leaf.style.left = (5 + Math.random()*90) + '%';
      leaf.style.bottom = (-40 - Math.random()*60) + 'px';
      leaf.style.animationDelay = (Math.random()*8) + 's';
      leaf.style.animationDuration = (10 + Math.random()*8) + 's';
      container.appendChild(leaf);
    }
  } catch(e){
    console && console.error && console.error(e);
  }
})();


// Live viewers randomizer + sticky ATC variant sync
document.addEventListener("DOMContentLoaded", function(){
  try {
    // live viewers
    var lv = document.querySelectorAll('.live-viewers');
    lv.forEach(function(el){
      var min = parseInt(el.getAttribute('data-min') || '8', 10);
      var max = parseInt(el.getAttribute('data-max') || '27', 10);
      var n = Math.floor(Math.random() * (max - min + 1)) + min;
      el.textContent = "👀 " + n + " people viewing now";
    });

    // sticky ATC variant sync
    var mainSelect = document.getElementById('ProductSelect');
    var stickyInput = document.getElementById('StickyProductSelect');
    if (mainSelect && stickyInput) {
      mainSelect.addEventListener('change', function(){
        stickyInput.value = this.value;
      });
    }
  } catch(e){}
});
